import Clarity from '@microsoft/clarity'
import { AUTH_TOKEN } from '../../../constants'

// Microsoft Clarity project ID
const CLARITY_PROJECT_ID = 'x0sz0d5sga'

const isLoggedIn = () => {
  try {
    return Boolean(localStorage.getItem(AUTH_TOKEN))
  } catch (e) {
    return false
  }
}

let started = false

// Start Clarity (heatmaps + session recordings). Runs at most once, and only
// for non-authenticated visitors (prospects) — we don't record app users.
export const initClarity = () => {
  if (typeof window === 'undefined') return
  if (isLoggedIn()) return
  if (started) return
  started = true
  Clarity.init(CLARITY_PROJECT_ID)
}
